module.exports = __webpack_public_path__ + "img/PC_JP.fb10dbd5.svg";